// Components==============
import Graph from 'components/UI/Graph/Graph';
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { useSelector } from 'react-redux';
import { getDate } from 'utilities/getDate';
import './FlashGraph.module.scss';
// =========================

export default function FlashGraph() {
    const graphData =
        useSelector((state: ReduxStore) => {
            const today = new Date();
            const lastWeek = new Date(
                today.getFullYear(),
                today.getMonth(),
                today.getDate() - 6
            ).getTime();

            return state.graphData?.entities.allIds
                .map((id) => state.graphData?.entities.byId[id])
                .filter((item) => getDate(item?.updated_at) >= lastWeek);
        }) || [];

    const goal = parseInt(
        graphData[graphData?.length - 1]?.correct_answer || '0'
    );

    return (
        <AnimatePresence>
            <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                styleName="wrapper"
            >
                <div>
                    <h6>Voortgang flitsen</h6>
                    <p styleName="description">
                        Aantal woorden per minuut. Het doel van deze flitslijst
                        was {goal} woorden.
                    </p>
                </div>
                <div styleName="graph">
                    {!!graphData && (
                        <Graph data={graphData} weekGoal={goal} hideOverflow />
                    )}
                </div>
            </motion.div>
        </AnimatePresence>
    );
}
